<!-- File: src/components/ui/Badges/BadgeAccent.vue -->
<template>
	<AppBadge variant="accent" :text="text" :count="count" :size="size" :isClickable="isClickable" :ariaLabel="ariaLabel" :isDot="isDot" @click="$emit('click')">
		<slot />
	</AppBadge>
</template>

<script>
import { defineComponent } from "vue";
import AppBadge from "../AppBadge.vue";

export default defineComponent({
	name: "BadgeAccent",
	components: { AppBadge },
	props: {
		text: { type: String, default: "" },
		count: { type: [Number, String], default: null },
		size: { type: String, default: "medium", validator: (s) => ["small", "medium", "large"].includes(s) },
		isClickable: { type: Boolean, default: false },
		ariaLabel: { type: String, default: "" },
		isDot: { type: Boolean, default: false },
	},
	emits: ["click"],
});
</script>
